import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

//global reveal triggers
//When trigger class is position from the bottom in view toggle the "revealed" class
//what happens when that class is added is up to the css
const reveal = gsap.utils.toArray('.js-trigger-animate');
reveal.forEach(reveal => {

    // Content Reveal Animation
    ScrollTrigger.create({
        start: "top bottom-=15%",
        trigger: reveal,
        onEnter: ({progress, direction, isActive}) => reveal.classList.add('animated'),
    });

});